import React from 'react';
import '../../styles/common/TopBar.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFacebook,
    faInstagram,
    faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

interface TopBarProps {
    children?: React.ReactNode;
    hideSocial?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ children, hideSocial }) => {
    return (
        <div className="top-bar">
            <div className="top-bar-content">
                <div className="top-bar-left">{children}</div>
                {!hideSocial && (
                    <div className="top-bar-social">
                        <a 
                            href="https://www.instagram.com/elpake.t"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <FontAwesomeIcon icon={faInstagram} />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopBar;
